var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex w-50 h-100 p-3 mx-auto flex-column p-5 my-5 bg-light rounded shadow-sm"},[_c('h1',[_vm._v("Oops! 🤔")]),_c('h3',[_vm._v("Denna sidan finns ej. Prova att "),_c('router-link',{attrs:{"to":{ name: 'guide' }}},[_vm._v("gå till guiden.")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }